import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M2.522 1.884L8 .667l5.478 1.217a.667.667 0 01.522.65v6.659a4 4 0 01-1.781 3.328L8 15.333l-4.219-2.812A4 4 0 012 9.193V2.535a.667.667 0 01.522-.651zm.811 1.185v6.124a2.667 2.667 0 001.188 2.218L8 13.731l3.48-2.32a2.665 2.665 0 001.187-2.218V3.07L8 2.033 3.333 3.07zm5.334 3.598h2l-3.334 4.666V8h-2l3.334-4.667v3.334z"
      ></path>
    </svg>
  )
}

export default Icon
